import * as React from "react"
import {Box, Grid} from "@mui/material";
import {ImageSeeker} from "@ui-seeker/core";

import {DIPBrand, DIPSku} from "@components";
import {BACKEND_APIS} from "@constants";
import {useBuildExternalURL, useUserApp} from "@hooks";
import {adminProductReviewErrorFormData, brandForm, countryForm, siteForm, skuForm} from "../@signals";
import AdminProductReviewFormIACardsOptions from "./IaCardsOptions";


export default function AdminProductReviewFormDrawerContent({formData}) {

    const { userCustomer } = useUserApp()
	const { imageURL } = useBuildExternalURL({
		imageData: { skuID: skuForm.value }
	})

    const myProps = {
            brand: { grid: { xs: 12 }, multiple: false, helperText: "Leave the field empty if you don\'t want to associate the product with any brand." },
            sku: { grid: { xs: 12 }, multiple: false, helperText: "Leave the field empty if you don\'t want to associate the product with any sku." }
    }

    return <Grid container spacing={2}>
        <Grid item {...myProps?.brand?.grid}>
            <DIPBrand
                error={adminProductReviewErrorFormData.value?.brand}
                label="Brand"
                placeholder="Search Brand..."
                value={brandForm.value}
                onChange={e => {
                    brandForm.value = e.target.value
                }}
                {...myProps?.brand}
            />
        </Grid>

        <Grid item {...myProps?.sku?.grid}>
            <DIPSku
                urlAjax={userCustomer === 5 ? `${BACKEND_APIS.MASTER_DATA}/sku/retailer-find` : `${BACKEND_APIS.MASTER_DATA}/sku/find`}
                error={adminProductReviewErrorFormData.value?.sku}
                filters={{
                    brand: brandForm.value, retailer: siteForm.value, country: countryForm.value,
                }}
                label="SKU"
                placeholder="Search SKU..."
                value={skuForm.value}
                limitTags={4}
                onChange={e => skuForm.value = e.target.value}
                {...myProps?.sku}
            />
        </Grid>

        {!!skuForm.value && <Box sx={{ margin: 1 }}>
			<ImageSeeker src={imageURL} height="auto" width="250px"/>
        </Box>}

        { !!formData.IAOptionsData?.length && <Grid item xs={12} >
            <AdminProductReviewFormIACardsOptions IAOptionsData={formData.IAOptionsData} />
        </Grid> }
    </Grid>
}